import React, { Component } from "react";
import {
  Container,
  Col,
  Form,
  FormGroup,
  Spinner,
  Button,
} from "react-bootstrap";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import {
  GetClusters,
  GetAreas,
  GetBranchByCode,
} from "../../../../store/actions/crdm_service_actions";

import {
  GetInventoryTargetOverallV4,
  GetInventoryTargetAreaV4,
  GetInventoryTargetClusterV4,
  GetInventoryTargetBranchV4,
} from "../../../../store/actions/reports-v4/inventory_target_actions";

import { connect } from "react-redux";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import { closeModal } from "../../../../store/actions/ModalActions";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { SetChartInventoryTargetTitle } from "../../../../store/actions/reports/chart_title_actions";
import { toastr } from "react-redux-toastr";

import AsyncSelect from "react-select/async";

const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(0);
toDate.setMonth(toDate.getMonth());

class InventoryTargetFilterView extends Component {
  state = {
    clusters: [],
    areas: [],
    branches: [],

    from: fromDate,
    to: toDate,

    isBusy: false,

    toView: "overall",
    previewText: "All Clusters",
    isClusterLoading: false,
    isAreaLoading: false,

    clusterSelectContext: null,
    areaSelectContext: null,

    clusterId: null,
    areaId: null,
  };

  componentDidMount() {
    this.openLoading();
    this.props.GetClusters().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isClusterLoading: false, clusters: resp.data });
      }
    });

    this.props.GetAreas().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isAreaLoading: false, areas: resp.data });
      }
    });

    this.closeLoading();
  }

  openLoading = () => {
    this.setState({ isClusterLoading: true, isAreaLoading: true });
  };
  closeLoading = () => {
    this.setState({ isClusterLoading: false, isAreaLoading: false });
  };

  handleCluster = (d) => {
    this.setState({
      clusterId: d.target.value.id,
      clusterSelectContext: d.target.value,
    });
  };
  handleArea = (d) => {
    this.setState({
      areaId: d.target.value.areaCode,
      areaSelectContext: d.target.value,
    });
  };

  handleRadioChanged = (e) => {
    this.setState({
      toView: e.target.value,
      clusterId: null,
      areaId: null,
      areaSelectContext: null,
      clusterSelectContext: null,
    });

    switch (e.target.value) {
      case "clusters":
        this.setState({ previewText: "All Clusters" });
        break;

      case "areas":
        this.setState({ previewText: "All Areas" });

        break;
      default:
        this.setState({ previewText: "No Values" });
        break;
    }
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branches: fieldData });
  };

  handleFromDate = (fieldData) => {
    this.setState({ from: fieldData });
  };

  handleToDate = (fieldData) => {
    this.setState({ to: fieldData });
  };

  renderClusters = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Cluster</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.clusterSelectContext}
          onChange={this.handleCluster}
        >
          {this.state.clusters.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                <span>{data.name} </span>
                <span className="text-danger ml-2 bold">{data.code}</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  renderAreas = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.areaSelectContext}
          onChange={this.handleArea}
        >
          {this.state.areas.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                {`${data.areaName}`}
                <span className="text-danger">({data.areaCode})</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  renderBranches = () => {
    return (
      <FormControl variant="filled" fullWidth>
        <AsyncSelect
          isMulti={true}
          placeholder="Enter Branch Codes"
          cacheOptions
          defaultOptions
          onChange={this.handlebranchCode}
          loadOptions={this.loadOptions}
        />
      </FormControl>
    );
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code);
  };
  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        if (resp.problem === null) {
          if (resp.data && resp.data.length > 0) {
            const currentItem = resp.data[0];
            return callback([
              {
                label: `(${currentItem.branchCode}) ${currentItem.branchName}`,
                value: currentItem.branchCode,
              },
            ]);
          }

          return callback([]);
        }

        return callback([]);
      });
    } else {
      return callback([]);
    }
  };

  renderFilterView = () => {
    switch (this.state.toView) {
      case "clusters":
        return this.renderClusters();

      case "areas":
        return this.renderAreas();

      case "branches":
        return this.renderBranches();

      default:
        return "";
    }
  };

  render() {
    return (
      <Container>
        <Form>
          <Form.Row>
            <FormGroup as={Col}>
              <FormControl className="d-inline">
                <RadioGroup
                  row
                  value={this.state.toView}
                  onChange={this.handleRadioChanged}
                >
                  <FormControlLabel
                    value="overall"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="overall"
                        name="radio-button"
                      />
                    }
                    label="Overall"
                  />
                  <FormControlLabel
                    value="clusters"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="clusters"
                        name="radio-button"
                      />
                    }
                    label="Clusters"
                  />
                  <FormControlLabel
                    value="areas"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="areas"
                        name="radio-button"
                      />
                    }
                    label="Areas"
                  />
                  <FormControlLabel
                    value="branches"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="branches"
                        name="radio-button"
                      />
                    }
                    label="Branches"
                  />
                </RadioGroup>
              </FormControl>
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>{this.renderFilterView()}</FormGroup>
          </Form.Row>

          <Form.Row>
            <FormGroup as={Col}>
              <DatePicker
                disableToolbar
                className="form-control"
                fullWidth
                autoOk
                disableFuture
                variant="inline"
                inputVariant="outlined"
                inline
                format="MMMM YYYY"
                views={["year", "month"]}
                label="From"
                showTodayButton={true}
                onChange={this.handleFromDate}
                value={this.state.from}
              />
            </FormGroup>
            <FormGroup as={Col}>
              <DatePicker
                disableToolbar
                className="form-control"
                fullWidth
                autoOk
                disableFuture
                variant="inline"
                inputVariant="outlined"
                inline
                format="MMMM YYYY"
                label="To"
                views={["year", "month"]}
                onChange={this.handleToDate}
                value={this.state.to}
              />
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>
              <Button
                disabled={this.state.isBusy}
                onClick={() => {
                  this.setState({ isBusy: true });
                  let { clusterId, areaId } = this.state;

                  switch (this.state.toView) {
                    case "overall":
                      this.premiseGetOverAll().then((result) => {
                        if (result.problem === null) {
                          closeModal();
                        } else {
                          this.setState({ isBusy: false });
                        }
                      });
                      break;

                    case "clusters":
                      if (clusterId !== null) {
                        this.premiseGetInventoryTargetByCluster(clusterId).then(
                          (result) => {
                            if (result.problem === null) {
                              closeModal();
                            } else {
                              this.setState({ isBusy: false });
                            }
                          }
                        );
                      } else {
                        toastr.confirm(`Please specify a cluster to proceed.`, {
                          disableCancel: true,
                        });

                        this.setState({ isBusy: false });
                      }

                      break;

                    case "areas":
                      if (areaId !== null) {
                        this.premiseGetInventoryTargetByArea(areaId).then(
                          (result) => {
                            if (result.problem === null) {
                              closeModal();
                            } else {
                              this.setState({ isBusy: false });
                            }
                          }
                        );
                      } else {
                        toastr.confirm(`Please specify area to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }

                      break;

                    case "branches":
                      if (this.state.branches.length > 0) {
                        this.premiseGetInventoryTargetByBranch(
                          this.state.branches.map((item) => item.value)
                        ).then((result) => {
                          if (result.problem === null) {
                            closeModal();
                          } else {
                            this.setState({ isBusy: false });
                          }
                        });
                      } else {
                        toastr.confirm(`Please specify a branch to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }

                      break;

                    default:
                      break;
                  }
                }}
                className="mt-2 float-right"
              >
                {!this.state.isBusy ? (
                  "View"
                ) : (
                  <Spinner size="sm" animation="border" />
                )}
              </Button>
            </FormGroup>
          </Form.Row>
        </Form>
      </Container>
    );
  }

  premiseGetOverAll = () => {
    var chartTitle = renderChartTitle(
      moduleNames.inventoryTarget,
      OperationScope.overall,
      moment(this.state.from).format("MMMM DD YYYY"),
      moment(this.state.to).format("MMMM DD YYYY")
    );

    this.props.SetChartInventoryTargetTitle(chartTitle);

    return this.props.GetInventoryTargetOverallV4({
      from_month: moment(this.state.from).format("MM"),
      from_year: moment(this.state.from).format("YYYY"),
      to_month: moment(this.state.to).format("MM"),
      to_year: moment(this.state.to).format("YYYY"),
    });
  };

  premiseGetInventoryTargetByCluster = (clusterId) => {
    var chartTitle = renderChartTitle(
      moduleNames.inventoryTarget,
      OperationScope.specifiedCluster,
      moment(this.state.from).format("MMMM DD YYYY"),
      moment(this.state.to).format("MMMM DD YYYY"),
      `${this.state.clusterSelectContext.name} (${this.state.clusterSelectContext.code})`
    );
    this.props.SetChartInventoryTargetTitle(chartTitle);

    return this.props.GetInventoryTargetClusterV4({
      from_month: moment(this.state.from).format("MM"),
      from_year: moment(this.state.from).format("YYYY"),
      to_month: moment(this.state.to).format("MM"),
      to_year: moment(this.state.to).format("YYYY"),
      clusterId: clusterId,
    });
  };

  premiseGetInventoryTargetByArea = (areaId) => {
    var chartTitle = renderChartTitle(
      moduleNames.inventoryTarget,
      OperationScope.specifiedArea,
      moment(this.state.from).format("MMMM DD YYYY"),
      moment(this.state.to).format("MMMM DD YYYY"),
      null,
      `${this.state.areaSelectContext.areaName} (${this.state.areaSelectContext.areaCode})`
    );
    this.props.SetChartInventoryTargetTitle(chartTitle);

    return this.props.GetInventoryTargetAreaV4({
      from_month: moment(this.state.from).format("MM"),
      from_year: moment(this.state.from).format("YYYY"),
      to_month: moment(this.state.to).format("MM"),
      to_year: moment(this.state.to).format("YYYY"),
      areaId: areaId,
    });
  };

  premiseGetInventoryTargetByBranch = (branch_codes) => {
    var chartTitle = renderChartTitle(
      moduleNames.inventoryTarget,
      OperationScope.specifiedBranch,
      moment(this.state.from).format("MMMM DD YYYY"),
      moment(this.state.to).format("MMMM DD YYYY"),
      null,
      null,
      `Branch (${branch_codes}) `
    );
    this.props.SetChartInventoryTargetTitle(chartTitle);

    return this.props.GetInventoryTargetBranchV4({
      from_month: moment(this.state.from).format("MM"),
      from_year: moment(this.state.from).format("YYYY"),
      to_month: moment(this.state.to).format("MM"),
      to_year: moment(this.state.to).format("YYYY"),
      branch_codes: branch_codes,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    clusters: state.crdm.cluster,
    areas: state.crdm.area,
  };
};

const mapDispatchToProps = {
  GetClusters: GetClusters,
  GetAreas: GetAreas,
  SetChartInventoryTargetTitle: SetChartInventoryTargetTitle,
  GetInventoryTargetOverallV4: GetInventoryTargetOverallV4,
  GetInventoryTargetAreaV4: GetInventoryTargetAreaV4,
  GetInventoryTargetClusterV4: GetInventoryTargetClusterV4,
  GetBranchByCode: GetBranchByCode,
  GetInventoryTargetBranchV4: GetInventoryTargetBranchV4,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryTargetFilterView);
